import { render, staticRenderFns } from "./AdminDepositShowTabular.vue?vue&type=template&id=79e85579&scoped=true&"
import script from "./AdminDepositShowTabular.vue?vue&type=script&lang=ts&"
export * from "./AdminDepositShowTabular.vue?vue&type=script&lang=ts&"
import style0 from "./AdminDepositShowTabular.vue?vue&type=style&index=0&id=79e85579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e85579",
  null
  
)

export default component.exports